import { render, staticRenderFns } from "./PrincipaisDestinosExpo.vue?vue&type=template&id=581b4444"
import script from "./PrincipaisDestinosExpo.vue?vue&type=script&lang=js"
export * from "./PrincipaisDestinosExpo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports